import { normalizeRecordResponse, sessionParams } from 'api';
import { client, computeHeaders } from 'queries';

export const sessionQuery = async ({ req, params, query }) => {
	const formattedParams = { ...sessionParams, context: query.context ? query.context : ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/session`, headers, params: formattedParams });
	return normalizeRecordResponse(response);
};
